import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "Card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "You are logging out", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-danger",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout_user && _ctx.logout_user(...args)))
      }, "Confirm"),
      _createVNode(_component_router_link, {
        class: "btn btn-primary",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}